import src from "IMAGE";
export default { src, width: 1440, height: 477, blurWidth: 8, blurHeight: 3, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAYAAACuyE5IAAAAQklEQVR42lXIsRGAIBQE0bU6NMdc61THBpQKgFaODwwBwZu9OTiTqmWS28cRBf4T/lfv2GYPxoq7hLvVO7ZZH7G9Ku/iMwCAGQISAAAAAElFTkSuQmCC"};
